import Super from 'client-portal/controllers/-request/information/review';

export default class WidgetInformationReview extends Super {}
